import { getAutomationPieces } from 'api/automation/automationService.js';

export default {
    data() {
        return {
            piecesList: [],
        };
    },
    methods: {
        initializePiecesList(automations) {
            const pieces = this.getUniquePieceNames(automations);
            if (pieces.length === 0) {
                this.piecesList = [];
                return Promise.resolve();
            }
            return this.getAutomationPieces(pieces)
                .then((results) => {
                    this.piecesList = results;
                    for (const automation of automations) {
                        const automationPieceNames = this.getPieceNamesForAutomation(automation);
                        automation.pieces = automationPieceNames
                            .map((pieceName) => {
                                return this.piecesList.find((piece) => {
                                    return piece && piece.originalPieceName === pieceName;
                                });
                            })
                            .filter((piece) => piece);
                    }
                })
                .catch(() => {
                    this.piecesList = [];
                });
        },
        getUniquePieceNames(flows) {
            const pieceNames = new Set();

            for (const flow of flows) {
                const trigger = flow.version?.trigger;
                if (trigger) {
                    this.extractPieceNames(trigger, pieceNames);
                }
            }
            return Array.from(pieceNames);
        },
        getPieceNamesForAutomation(automation) {
            const pieceNames = new Set();
            const trigger = automation.version?.trigger;
            if (trigger) {
                this.extractPieceNames(trigger, pieceNames);
            }
            return Array.from(pieceNames);
        },
        extractPieceNames(action, pieceNames) {
            if (!action || typeof action !== 'object') {
                return;
            }

            if (action.settings?.pieceName) {
                pieceNames.add(action.settings.pieceName);
            }

            if (action.nextAction) {
                this.extractPieceNames(action.nextAction, pieceNames);
            }

            if (Array.isArray(action.children)) {
                for (const child of action.children) {
                    this.extractPieceNames(child, pieceNames);
                }
            }

            if (action.firstLoopAction) {
                this.extractPieceNames(action.firstLoopAction, pieceNames);
            }
        },
        getAutomationPieces(pieceNames) {
            const cleanedPieceNames = pieceNames.map((name) => {
                if (name.startsWith('@activepieces/')) {
                    return name.replace('@activepieces/', '');
                }
                return name;
            });

            return getAutomationPieces(cleanedPieceNames)
                .then((response) => {
                    const piecesData = response.data;
                    const results = [];
                    for (let i = 0; i < pieceNames.length; i++) {
                        const originalPieceName = pieceNames[i];
                        const cleanedPieceName = cleanedPieceNames[i];
                        const pieceData = piecesData[cleanedPieceName];
                        if (pieceData) {
                            results.push({
                                displayName: pieceData.displayName,
                                logoUrl: pieceData.logoUrl,
                                originalPieceName: originalPieceName,
                            });
                        }
                    }

                    return results;
                })
                .catch((error) => {
                    this.errorsHandler.logException(error);
                    this.$pushToast({
                        type: 'error',
                        close: true,
                        text: this.$t.__('common.labels.toast.error'),
                    });
                    return [];
                });
        },
    },
};
